import models from './rndModelsData.json';

const rnd = { models };

export default rnd;